import { useDispatch } from "react-redux";
import { useReducer, useCallback } from "react";
import React from "react";

export const useCallbackDispatch = (type) => {
  const dispatch = useDispatch();
  return useCallback((payload) => dispatch({ type, payload }), [
    dispatch,
    type,
  ]);
};

export const useComposeDispatcher = (...args) => {
  const dispatch = useDispatch();
  return args.map((type) => (payload) => dispatch({ type, payload }));
};

export const useDefaultReducer = (initialState) => {
  const [state, _dispatch] = useReducer(
    (_state, { type, payload }) => ({ ..._state, [type]: payload }),
    initialState
  );
  const dispatch = (type) => (payload) => _dispatch({ type, payload });

  return [state, dispatch, _dispatch];
};

/* // Hook for managing API version state
export const useApiVersion = () => {
  const [selectedVersion, setSelectedVersion] = React.useState(
    localStorage.getItem('selected-api-version') || 'galen_cloud'
  );

  const updateApiVersion = React.useCallback((newVersion) => {
    setSelectedVersion(newVersion);
    localStorage.setItem('selected-api-version', newVersion);
  }, []);

  const getCurrentApiUrl = React.useCallback(() => {
    const { API_ENDPOINTS } = require('./constants');
    return API_ENDPOINTS[selectedVersion] || API_ENDPOINTS['galen_cloud'];
  }, [selectedVersion]);

  return {
    selectedVersion,
    updateApiVersion,
    getCurrentApiUrl
  };
};
 */